<template>
	<el-dialog
		title="拆分资源"
		:visible.sync="dialogVisible"
		width="30%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="plan-dialog">
		<div class="msg">当前资源：{{ data.resourceNo }} - {{ data.resourceName }}</div>
		<div class="msg">面积： {{ data.area }} ㎡</div>
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 拆分数 -->
				<el-col :span="24">
					<el-form-item label="拆分数" prop="splitCount">
						<el-input
							v-model.number="form.splitCount"
							size="small"
							type="number"
							placeholder="请填写拆分数（2-5）"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 合同内容 -->
				<el-col :span="24">
					<el-form-item label="拆分说明" prop="description">
						<el-input
							type="textarea"
							v-model="form.description"
							size="small"
							placeholder="请填写拆分说明和原因"
							:rows="4" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { getResourceSplit } from '@/api/asset/resourceApi';
	export default {
		name: 'ResourceManageSplitDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					description: '',
					resourceId: '',
					splitCount: '',
				},
				rules: {
					splitCount: [
						{ required: true, message: '请填写拆分数', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								if (value === null || value === undefined) {
									return callback(new Error('请填写拆分数'));
								}

								if (!Number.isInteger(value)) {
									return callback(new Error('必须为整数'));
								}

								if (value < 2 || value > 5) {
									return callback(new Error('拆分数应为2-5之间'));
								}

								callback();
							},
							trigger: 'blur',
						},
					],
				},
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					getResourceSplit({
						resourceId: this.data.id,
						splitCount: this.form.splitCount,
						description: this.form.description,
					})
						.then(() => {
							this.$message.success('资源拆分成功');
							this.$emit('updateSuccess');
						})
						.catch(err => {
							console.log(err);
							this.$message.error('资源拆分失败');
						})
						.finally(() => {
							this.handleClose();
						});
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.msg {
		color: #333;
		margin-bottom: 5px;
	}
</style>
